import { isBedbankOffer, isLEHotel, isLpcHotelOffer } from 'lib/offer/offerTypes'

function isCalendarYmalOffer(offer: App.AnyOffer): offer is App.HotelOffer | App.BedbankOffer {
  return isLEHotel(offer) || isLpcHotelOffer(offer) || isBedbankOffer(offer)
}

export { isCalendarYmalOffer }
